/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formatter_Deep_TitleInputs */

const en_formatter_deep_title = /** @type {(inputs: Formatter_Deep_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What changes besides whitespace`)
};

const ko_formatter_deep_title = /** @type {(inputs: Formatter_Deep_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`공백 외에 무엇이 바뀌는가`)
};

const ja_formatter_deep_title = /** @type {(inputs: Formatter_Deep_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`空白以外に何が変わるか`)
};

/**
* | output |
* | --- |
* | "What changes besides whitespace" |
*
* @param {Formatter_Deep_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const formatter_deep_title = /** @type {((inputs?: Formatter_Deep_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formatter_Deep_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_formatter_deep_title(inputs)
	if (locale === "ko") return ko_formatter_deep_title(inputs)
	return ja_formatter_deep_title(inputs)
});